module.exports = __webpack_public_path__ + "static/media/peijiansuopei642.e72d0da6.png";